import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import './fonts/file.ttf';
import './fonts/file.otf';
import "./index.css";


ReactDOM.render(<App />, document.getElementById("root"));
